import { Navigation, Swiper } from 'swiper';
import { isMobile } from '@/modules/functions';

export class EquipmentSlider {
  slider;

  constructor() {}

  init() {
    const equipment = document.querySelector('.card-work-equipment');
    if (!equipment) return;

    Swiper.use([Navigation]);

    this.slider = new Swiper('.card-work-equipment-slider', {
      slidesPerView: 2,
      loop: true,
      navigation: {
        prevEl: isMobile()
          ? '.card-work-equipment-slider-prev'
          : '.card-work-equipment-navigation-prev',
        nextEl: isMobile()
          ? '.card-work-equipment-slider-next'
          : '.card-work-equipment-navigation-next',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
      },
    });
  }
}
